import {WdiPanel} from "@/components/WdiControls/WdiPanel";
import React, {useEffect, useState} from "react";
import {WdiCardTitle, wdiCore, WdiModalProps} from "@/components/WdiControls";
import {Enum} from "@/enums/system";
import {message, Modal} from "antd";
import {ResponseStatus} from "@/utils/request";
import {WdiTable} from "@/components/WdiControls/WdiTable";
import ProductPolicySoldToEditPanel from "@/pages/policy/ProductPolicyApply/components/SoldTo/soldToEdit";
import {ProductPolicy} from "@/services/policy/productpolicy";
import {ImportModalApp} from "@/components/WdiControls/WdiImport";
import {toExcel, ToExcelProps} from "@/components/WdiControls/WdiExcel";
import {SoldTo} from "@/services/mdm/soldto";
import {SoldToGroup} from "@/services/mdm/soldtogroup";
import DataStore, {uuidv4} from "@/components/GridWidget/DataStore";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {OpenModeEnum} from "@/pages/policy/ProductPolicyApply/components/apply";
import {defaultPolicySoldToDateArr} from "@/pages/policy/ProductPolicyApply/data";

const {confirm} = Modal;

export const ModalTypeEnums = {
  None: 0,
  Insert: 1,
  Import: 2,
  Clean: 3,
  Edit: 4,
};

const ProductPolicySoldToApplyPanel: React.FC<any> = (props: any) => {
  const [importExcels, setImportExcels] = useState<ToExcelProps[]>([]);
  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false});
  const [productPolicy, setProductPolicy] = useState<API.ProductPolicy>({});
  const [isLoaded, setIsLoaded] = useState(false);
  const [dataSource, setDataSource] = useState<API.ProductPolicySoldToQueryPo[]>([])
  const [columns, setColumns] = useState<any>()
  const [collapsed, setCollapsed] = useState<boolean>(true);

  const onclick = (record: any) => {
    fetchProductPolicy();
    setModalProps({
      visible: true,
      title: '新建适用客户/返利客户组',
      type: ModalTypeEnums.Edit,
      data: record
    });
  }

  // 客户编号，客户名称，四级级使用部门，三级级使用部门，二级级使用部门，一级级使用部门
  const getSoldToSheet = () => {
    const soldToColumns = [
      {name: "soldToCode", displayName: "客户编号"},
      {name: "soldToName", displayName: "客户名称"},
      {name: "boName4", displayName: "四级使用部门"},
      {name: "boName3", displayName: "三级使用部门"},
      {name: "boName2", displayName: "二级使用部门"},
      {name: "boName1", displayName: "一级使用部门"}
    ];
    return {
      dataLoading: async (params: any) => {
        return await SoldTo.queryForSheet(Object.assign({
          withPermissions: true,
          isActive: true,
          soldToLevel: 1
        }, params));
      },
      data: null,
      names: soldToColumns,
      sheetName: "客户列表",
    };
  }

  const getSoldToGroupSheet = () => {
    const soldToColumns = [
      {name: "soldToGroupCode", displayName: "返利客户组编号"},
      {name: "soldToGroupName", displayName: "返利客户组名称"},
      {name: "relatedSoldToNames", displayName: "相关客户"}
    ];
    return {
      dataLoading: async (params: any) => {
        return await SoldToGroup.queryForSheet(Object.assign({
          withPermissions: true,
          isActive: true,
        }, params));
      },
      data: null,
      names: soldToColumns,
      sheetName: "返利客户组列表",
    };
  }

  const initImportExcel = () => {
    const soldToSheet = getSoldToSheet();
    const soldToGroupSheet = getSoldToGroupSheet();
    const importExcels: ToExcelProps[] = [];
    importExcels.push({
      name: "全部下载",
      sheetProps: [soldToSheet, soldToGroupSheet]
    });
    importExcels.push({
      name: "客户列表",
      sheetProps: [soldToSheet, soldToGroupSheet]
    });
    setImportExcels(importExcels);
  }

  const columnList = [
    {
      title: '返利客户组',
      dataIndex: 'soldToGroupName',
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.String.CodeOrName(record.soldToGroupCode,record.soldToGroupName);
      }
    },
    {
      title: '客户',
      dataIndex: 'soldToName',
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.String.CodeOrName(record.soldToCode,record.soldToName);
      }
    },
    {
      title: '相关客户',
      dataIndex: 'relatedSoldToNames',
      ellipsis: true,
      render: (value: any, record: any) => {
        return value;
      }
    }, {
      title: '开始日期',
      dataIndex: 'startDateShow',
      ellipsis: true,
      render: (value: any, record: any) => {
        return value;
      }
    },
    {
      title: '截止日期',
      dataIndex: 'endDateShow',
      ellipsis: true,
      render: (value: any, record: any) => {
        return value;
      }
    },
    {
      title: '备注',
      dataIndex: 'remark',
      ellipsis: true,
      render: (value: any, record: any) => {
        return value;
      }
    }
  ];

  const columnList2 = [{
    title: '操作',
    dataIndex: 'option',
    ellipsis: true,
    render: (value: any, record: any) => {
      return <a onClick={() => {
        onclick(record)
      }}>编辑</a>
    }
  }].concat(columnList);

  const fetchProductPolicy = () => {
    const productPolicy: any = props.getProductPolicy?.() ?? {};
    setProductPolicy(productPolicy);
  };

  useEffect(() => {
    initImportExcel();
    setIsLoaded(true);
    props.dataSource.forEach((item: { startDate: string; endDate: string; uid: string; startDateShow: string; endDateShow: string; }) => {
      item.startDateShow = defaultPolicySoldToDateArr.includes(item.startDate) ? '' : item.startDate;
      item.endDateShow = defaultPolicySoldToDateArr.includes(item.endDate) ? '' : item.endDate;
      item.uid = uuidv4()
    })
    setDataSource(props.dataSource)

    if (props.openMode === OpenModeEnum.UPDATE_PARTLY || props.openMode === OpenModeEnum.UPDATE) {
      setColumns(columnList2);
    } else {
      setColumns(columnList);
    }
    fetchProductPolicy();
  }, [props.dataSource]);

  const onClose = () => {
    setModalProps({visible: false, title: "", id: null});
  }

  const onImportSave = (uploadResult: any) => {
    if (uploadResult.code == ResponseStatus.SUCCESS) {
      let result = uploadResult?.data?.data;
      props.onChange?.(DataStore.init(result));
    }
    setModalProps({visible: false, title: "", id: null});
  }

  const exportButton = () => {
    return <a type='primary'
              onMouseOver={() => setCollapsed(false)}
              onMouseOut={() => setCollapsed(true)}
              onClick={() => {
                //客户编号，客户名称，返利客户组编号，返利客户组名称，相关客户（直接用related_sold_to_names即可），开始日期（若是1900显示为空），截止日期（若是2999显示为空），备注
                const exportColumns = [
                  {name: "soldToCode", displayName: "客户编号"},
                  {name: "soldToName", displayName: "客户名称"},
                  {name: "soldToGroupCode", displayName: "返利客户组编号"},
                  {name: "soldToGroupName", displayName: "返利客户组名称"},
                  {name: "relatedSoldToNames", displayName: "相关客户"},
                  {name: "startDate", displayName: "开始日期"},
                  {name: "endDate", displayName: "截止日期"},
                  {name: "remark", displayName: "备注"}
                ];
                dataSource.forEach((item: { startDate?: string; endDate?: string; }) => {
                  if (wdiCore.String.IsNullOrEmpty(item.startDate)) {
                    // @ts-ignore
                    item.startDate = null;
                  }
                  if (wdiCore.String.IsNullOrEmpty(item.endDate)) {
                    // @ts-ignore
                    item.endDate = null;
                  }
                })
                const formSASheet = {
                  data: dataSource,
                  names: exportColumns,
                  sheetName: "适用客户导出",
                  cells: {
                    startDate: (_fieldObject: any, _row: any, value: any) => {
                      return defaultPolicySoldToDateArr.includes(value) ? '' : value
                    },
                    endDate: (_fieldObject: any, _row: any, value: any) => {
                      return defaultPolicySoldToDateArr.includes(value) ? '' : value
                    }
                  }
                };
                toExcel({
                  name: "适用客户导出_" + wdiCore.Date.ToString(new Date()) + ".xlsx",
                  sheetProps: [formSASheet]
                })
              }} style={{float: 'right', marginRight: 10}}>
      导出
    </a>
  }

  const newButton = () => {
    return <a type='primary'
              onMouseOver={() => setCollapsed(false)}
              onMouseOut={() => setCollapsed(true)}
              onClick={() => {
                fetchProductPolicy();
                setModalProps({
                  visible: true,
                  title: '新建适用客户/返利客户组',
                  type: ModalTypeEnums.Insert
                });
              }} style={{float: 'right', marginRight: 10}}>
      新增
    </a>
  }

  const importButton = () => {
    return <a type='primary'
              onMouseOver={() => setCollapsed(false)}
              onMouseOut={() => setCollapsed(true)}
              onClick={() => {
                setModalProps({
                  visible: true,
                  title: '导入',
                  type: ModalTypeEnums.Import
                });
              }} style={{float: 'right', marginRight: 10}}>
      导入
    </a>
  }

  const cleanButton = () => {
    return <a type='primary'
              onMouseOver={() => setCollapsed(false)}
              onMouseOut={() => setCollapsed(true)}
              onClick={() => {
                confirm({
                  title: '确认要清除列表的数据内容吗？',
                  icon: <ExclamationCircleOutlined/>,
                  onOk() {
                    props.onChange?.([])
                    message.success("清除成功")
                  },
                });
              }} style={{float: 'right', marginRight: 10}}>
      清空
    </a>
  }

  const getOperations = () => {
    if (props.openMode === OpenModeEnum.UPDATE_PARTLY) {
      return <>
        {newButton()}
        {exportButton()}
      </>
    }
    if (props.openMode === OpenModeEnum.VIEW) {
      return <>
        {exportButton()}
      </>
    }
    return <>
      {importButton()}
      {cleanButton()}
      {newButton()}
    </>
  }

  return (<WdiPanel
    collapsed={collapsed}
    title={<WdiCardTitle iconType={Enum.IconType.BASE_INFO} title={'适用客户/返利客户组列表'}/>}
    extra={getOperations()}
  >
    {isLoaded && modalProps.visible && [ModalTypeEnums.Import].includes(modalProps.type ?? 0) &&
      <ImportModalApp
        title={modalProps.title}
        visible={modalProps.visible}
        settingsUrl="/expenseapi/productPolicy/getImportSettings"
        uploadingUrl="/expenseapi/productPolicy/importUploading"
        onClose={onClose}
        onSave={onImportSave}
        clientParameters={{
          productPolicySoldTos: JSON.stringify(dataSource),
          isExcludeSoldTo: props.isExcludeSoldTo ? 'N' : 'Y'
        }}
        importExcels={importExcels}
      />
    }
    {isLoaded && modalProps.visible && [ModalTypeEnums.Insert,ModalTypeEnums.Edit].includes(modalProps.type ?? 0) &&
      <ProductPolicySoldToEditPanel
        {...modalProps}
        openMode={props.openMode}
        productPolicy={productPolicy}
        onSave={async (result) => {
          if (result?.data) {
            if (!wdiCore.String.IsNullOrEmpty(result.data.startDateShow)) {
              result.data.startDateShow = (result?.data?.startDateShow ?? "").substring(0, 10)
              result.data.startDate = result.data.startDateShow;
            }
            if (!wdiCore.String.IsNullOrEmpty(result.data.endDateShow)) {
              result.data.endDateShow = (result?.data?.endDateShow ?? "").substring(0, 10)
              result.data.endDate = result.data.endDateShow;
            }
          }
          if(!result?.data) return;
          const currentProductPolicySoldTo = result.data;
          let innerDataSource:any[];
          if(currentProductPolicySoldTo.uid){
            innerDataSource = DataStore.edit(dataSource,currentProductPolicySoldTo)
          }else{
            innerDataSource = DataStore.add(dataSource,currentProductPolicySoldTo);
          }

          ProductPolicy.Buttons.validateProductPolicySoldTo({
            productPolicy: productPolicy,
            productPolicySoldTos: innerDataSource,
            currentProductPolicySoldTo: currentProductPolicySoldTo
          }).then((res: { code: number; message: any; data: any; }) => {
            if (res.code != ResponseStatus.SUCCESS || !result?.data) {
              message.error(res.message)
              return;
            }
            (async ()=>{
              if(currentProductPolicySoldTo.soldToCode){
               const soldToRes =  await SoldTo.get(currentProductPolicySoldTo.soldToCode);
               if(soldToRes.code != ResponseStatus.SUCCESS || !soldToRes?.data){
                 message.error(soldToRes.message);
                 return;
               }
               currentProductPolicySoldTo.soldToName = soldToRes?.data?.soldToName;
              }
              if(currentProductPolicySoldTo.soldToGroupId){
               const soldToGroupRes =  await SoldToGroup.get(currentProductPolicySoldTo.soldToGroupId);
                if(soldToGroupRes.code != ResponseStatus.SUCCESS || !soldToGroupRes?.data){
                  message.error(soldToGroupRes.message);
                  return;
                }
               const relatedSoldToRes =await SoldToGroup.getRelatedSoldTos(currentProductPolicySoldTo.soldToGroupId);
                if(relatedSoldToRes.code != ResponseStatus.SUCCESS || !relatedSoldToRes?.data){
                  message.error(relatedSoldToRes.message);
                  return;
                }
                currentProductPolicySoldTo.soldToGroupCode = soldToGroupRes.data.soldToGroupCode;
                currentProductPolicySoldTo.soldToGroupName = soldToGroupRes.data.soldToGroupName;
                currentProductPolicySoldTo.relatedSoldToNames = (relatedSoldToRes?.data??[])
                  .map(soldTo=>wdiCore.String.CodeOrName(soldTo.soldToCode,soldTo.soldToName)).join(",");
              }
              props.onChange?.(innerDataSource)
              onClose()
            })()
          })
        }}
        onClose={onClose}
      />
    }

    {isLoaded && <WdiTable columns={columns} dataSource={dataSource}/>}
  </WdiPanel>);
}

export default ProductPolicySoldToApplyPanel;
